<template>
  <div class="gift-sub-batches pane">
    <h3>Gift Subs</h3>

    <table class="batch-table">
      <thead>
        <tr>
          <th>Batch</th>
          <th>Date</th>
          <th>Status</th>
          <th>Sender</th>
          <th>Subs</th>
          <th>Amount</th>
          <!-- <th>Recipients</th> -->
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="batch of batches" :key="batch.id">
          <td class="id" v-text="batch.id" />
          <td :title="batch.created.toDate() | moment('MM/DD/YY H:mma [(UTC ]Z)')">{{ batch.created.toDate() | moment('from') }}</td>
          <td>
            <span
              class="icon emoji"
              :class="batch.status === 'resolved' ? 'approved': batch.status" />
            {{ batch.status }}
            <small v-if="batch.status === 'resolved'">
              {{ batch.resolveDate.toDate() | moment('from') }}
            </small>
          </td>
          <td>
            <router-link :to="`users/${batch.senderId}`">{{ batch.senderName }}</router-link>
          </td>
          <td>{{ batch.recipients.length }}x Tier {{ batch.tier }}</td>
          <td v-text="batch.pointsTotal" />
          <!-- <td>
            <router-link v-for="recipient of batch.recipients" :key="recipient.id" :to="`users/${recipient.id}`">{{ recipient.name }}</router-link>
          </td> -->
          <td>
            <button
              v-if="batch.status === 'pending'"
              @click="toggleModal(batch)">
              <i class="icon fas fa-gavel" />
              Allocate
            </button>
            <template v-else>
              <div>
                Resolved
                &ndash;
                {{ Math.round((1 - batch.splitAmount / batch.points) * 100) }}%
                /
                {{ Math.round(batch.splitAmount / batch.points * 100) }}%
                split
              </div>
            </template>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="modal"
      :class="{ active: modalActive }"
      @click.self="toggleModal()">
      <div class="pane">
        <div class="allocator-sides">
          <div class="label top">Sender</div>
          <div class="label top">Recipients ({{ recipientNames.length }})</div>

          <div class="names">
            <h3>{{ senderName }}</h3>
          </div>
          <div class="names">
            <div v-for="name of recipientNames" :key="name" v-text="name" />
          </div>

          <div class="label bottom">
            <!-- <small>{{ (splitAmountRemainder / amount) * 100 }}%</small><br /> -->
            {{ splitAmountRemainder }}
          </div>
          <div class="label bottom">
            <!-- <small>{{ ((splitAmount * recipientNames.length) / amount) * 100 }}%</small><br /> -->
            {{ splitAmount }} each
          </div>
        </div>
        <input
          class="split"
          type="range"
          min="0"
          max="1"
          step="0.01"
          v-model.number="split"
          :disabled="busy" />
        <button
          @click="resolveBatch(batchId, splitAmount)"
          :disabled="busy">Resolve</button>
        <button
          @click="toggleModal()"
          :disabled="busy">Close</button>
        <div v-if="busy">Working...</div>
        <div v-if="result" v-text="result" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ApiHelper from '../mixins/ApiHelper'

export default {
  name: 'GiftSubBatches',
  props: ['filter'],
  mixins: [ApiHelper],

  data () {
    return {
      busy: false,
      result: '',

      modalActive: false,
      batchId: '',
      amount: 0,
      senderName: '',
      recipientNames: [],
      split: 0
    }
  },

  computed: {
    ...mapState(['giftSubBatches']),

    batches () {
      if (!this.filter) {
        return this.giftSubBatches
      }

      return this.giftSubBatches
        .filter(({ status }) => status === this.filter)
    },

    splitAmount () {
      const len = this.recipientNames.length
      return ~~(Math.floor(this.amount * this.split) / len)
    },
    splitAmountRemainder () {
      return this.amount - (this.splitAmount * this.recipientNames.length)
    }
  },

  methods: {
    resolveBatch (batchId, splitAmount) {
      this.busy = true
      this.result = ''

      this
        .apiRequest(`giftsubs/${batchId}/resolve`, {
          method: 'post',
          data: {
            splitAmount
          }
        })
        .then(() => this.toggleModal())
        .catch((err) => {
          console.error(err)
          this.result = err.toString()
        })
        .finally(() => {
          this.busy = false
        })
    },
    toggleModal (batch) {
      if (batch) {
        this.batchId = batch.id
        this.amount = batch.pointsTotal
        this.senderName = batch.senderName
        this.recipientNames = batch.recipients.map(({ name }) => name)
        this.split = 0
      }
      this.modalActive = !this.modalActive
    }
  }
}
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #0006;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 100ms ease-out;
  opacity: 0;
}
.modal:not(.active) {
  pointer-events: none;
}
.modal.active {
  opacity: 1;
}
.modal .pane {
  background: white;
  padding: 1em;
  border-radius: 4px;
  box-shadow: 0 2px 20px #0006;
}
.modal .split {
  width: 100%;
}

.allocator-sides {
  min-width: 500px;
  min-height: 200px;
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: 2em auto 2em;
  text-align: center;
  margin-bottom: 1em;
}
.allocator-sides .names {
  align-self: center;
  max-height: 400px;
  overflow: auto;
}
.allocator-sides .label.bottom {
  align-self: end;
}

.batch-table {
  width: 100%;
}
.batch-table th {
  text-align: left;
}
.batch-table td.id {
  font-size: smaller;
  font-family: monospace;
}
</style>
